module.exports = __webpack_public_path__ + "img/code.a7989097.png";